import router from '../router/index';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import Vue from 'vue';
import getEnvVar from 'helper/envHelper';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    Vue,
    dsn: getEnvVar('SENTRY_DSN'),
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: [getEnvVar('HostDomainURL'), /^\//],
      }),
    ],
    tracesSampleRate: getEnvVar('SENTRY_TRANCE_SAMPLE_RATE'),
    tracingOptions: {
      trackComponents: true,
    },
    tracePropagationTargets: [
      getEnvVar('HostDomainURL')
    ],
    // Vue specific
    attachProps: true,
    attachStacktrace: true,
  });
}
